import React from "react";
import SVGIcon, { IconProps } from "ui/SVGIcon";

const path =
  "M7.75915 3.24304C4.7484 3.24304 2.17722 5.11573 1.1355 7.75917C2.17722 10.4026 4.7484 12.2753 7.75915 12.2753C10.7699 12.2753 13.3411 10.4026 14.3828 7.75917C13.3411 5.11573 10.7699 3.24304 7.75915 3.24304ZM7.75915 10.7699C6.09722 10.7699 4.7484 9.42111 4.7484 7.75917C4.7484 6.09724 6.09722 4.74842 7.75915 4.74842C9.42109 4.74842 10.7699 6.09724 10.7699 7.75917C10.7699 9.42111 9.42109 10.7699 7.75915 10.7699ZM5.9527 7.75917C5.9527 6.7596 6.75958 5.95272 7.75915 5.95272C8.75872 5.95272 9.56561 6.7596 9.56561 7.75917C9.56561 8.75874 8.75872 9.56562 7.75915 9.56562C6.75958 9.56562 5.9527 8.75874 5.9527 7.75917Z";

export default function RemoveRedEyeIcon(props: IconProps) {
  return <SVGIcon path={path} viewBox="0 0 15 15" {...props} />;
}
